import type { SearchProvider, SearchResult } from "../types.ts";
import { isNil } from "lodash-es";
import { takeWhere } from "../searchUtil.ts";
import { softContains } from "../../../utils/stringUtil.ts";
import Text from "../../../components/text/Text.tsx";
import type ApiService from "../../ApiService.ts";
import { IconTile } from "../../../components/icon/IconTile.tsx";
import { dataSourcesByType } from "../../../pages/customer/dataSource/dataSourcesByType.ts";

export class DataSourceSearchProvider implements SearchProvider {
  readonly type = "DATA_SOURCE";

  constructor(
    private readonly dataSourcesQuery: ReturnType<typeof ApiService.getDataSources>,
    private readonly maxResults: number,
  ) {}

  async search(query: string): Promise<SearchResult[]> {
    if (isNil(this.dataSourcesQuery.data)) {
      return [];
    }

    return Array.from(
      takeWhere(
        this.dataSourcesQuery.data,
        (dataSource) => dataSource.id.equals(query) || softContains(dataSource.name, query),
        this.maxResults,
      ).map((dataSource) => ({
        type: this.type,
        id: dataSource.id.toString(),
        ContentComponent: () => (
          <div
            class="grid min-w-0 grid-cols-template items-center gap-3 px-3 py-2.5"
            style={{
              "--column-template": "auto minmax(0, 1fr)",
            }}
          >
            <IconTile icon={dataSourcesByType[dataSource.type].icon} size="sm" border />
            <Text class="text-base-medium text-primary" as="p" text={dataSource.name} truncate />
          </div>
        ),
        actions: {
          Enter: {
            type: "navigate",
            href: (customerId) => `/customers/${customerId}/data-sources/${dataSource.id}`,
          },
        },
      })),
    );
  }
}
